import { action } from 'easy-peasy';
import { IActionSetAiTestResponse } from '../types';

const setAiTestResponse: IActionSetAiTestResponse = action((state, testAiResponse) => {
  state.testAiResponse = testAiResponse;
});

export default setAiTestResponse;
